module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/badges_png/reward_badge_aurora_ghost-9ee2916859fd7add643d525589d55147.png";